module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-cost-ab100ed1d0db54787ac9ef8d66ee5442.svg";